<template>
  <div class="threadUseInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      使用牙板資訊
    </li>
    <b-table
      :items="threadUseInformationItem"
      :fields="threadUseInformationFields"
      sticky-header="186px"
      :no-border-collapse="noBorderCollapse"
      class="text-center threadUseInformation-table-detail"
    >
      <template #cell(used_life)="data">{{
        data.value.toLocaleString("en-US")
      }}</template>
      <template #cell(standard_life)="data">{{
        data.value.toLocaleString("en-US")
      }}</template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "threadUseInformation",
  data() {
    return {
      noBorderCollapse: true,
    };
  },
  computed: {
    ...mapGetters({
      threadUseInformationFields:
        "threadUseInformation/get_threadUseInformationFields",
      threadUseInformationItem:
        "threadUseInformation/get_threadUseInformationItem",
    }),
  },
};
</script>

<style lang="scss">
.threadUseInformation-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.threadUseInformation-table-detail thead th {
  border-top: 1px solid;
}
.threadUseInformation-table-detail th,
.threadUseInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.threadUseInformation-table-detail th:first-child,
.threadUseInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.threadUseInformation-table-detail {
  margin-bottom: 0px;
}
.threadUseInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/threadUseInformation.vue